<template>
  <section class="section-registration">
    <img
      class="trebel-logo-redesign"
      :src="`${publicPath}assets/images/trebel_logo.png`"
      :alt="$t('TREBEL')"
    />
    <div class="container mt-minus-13">
      <div class="section-registration-inner  mt-56 mb-40">
        <div class="section-mobile-inner">
          <h3 class="registration-title">
            {{ $t("createYourFreeAccount") }}
          </h3>
          <div class="registration-subtitle">
            {{ $t("itsEasyJust") }}
          </div>
          <ui-socials></ui-socials>
          <div class="">
            <b-link
              class="registration-other-method content-center btn-social"
              :to="{
                name: 'CreateAccount',
                query: {
                  redirectTo: this.$route.query.redirectTo,
                  type: this.$route.query.type
                }
              }"
            >
              {{ $t("createWithEmail") }}
            </b-link>
          </div>
        </div>
        <hr />
        <div class="registration-login">
          <h4 class="registration-login-label">
            {{ $t("ifYouAlreadyHaveAnAccount") }}
          </h4>
          <b-link
            class="btn-social btn-social-login"
            :to="{
              name: 'Login',
              query: {
                redirectTo: $route.query.redirectTo,
                type: this.$route.query.type
              }
            }"
          >
            {{ $t("logIn") }}</b-link
          >
        </div>
        <div
          class="registration-copyright"
          v-html="$t('byContinuingYouAgreeToOur')"
        ></div>
      </div>
    </div>
  </section>
</template>

<script>
import UiSocials from "@/components/Ui/UiSocials";
export default {
  components: {
    UiSocials
  }
};
</script>
